import React from 'react';
import { Settings as SettingsIcon, User, Bell, Shield, Palette } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@plvplus/core';

export const Settings: React.FC = () => {
  const settingsCategories = [
    {
      title: 'Profil utilisateur',
      description: 'Gérez vos informations personnelles',
      icon: User,
      items: ['Informations personnelles', 'Mot de passe', 'Photo de profil']
    },
    {
      title: 'Notifications',
      description: 'Configurez vos préférences de notification',
      icon: Bell,
      items: ['Notifications email', 'Notifications push', 'Alertes système']
    },
    {
      title: 'Sécurité',
      description: 'Paramètres de sécurité et confidentialité',
      icon: Shield,
      items: ['Authentification 2FA', 'Sessions actives', 'Journaux d\'accès']
    },
    {
      title: 'Apparence',
      description: 'Personnalisez l\'interface',
      icon: Palette,
      items: ['Thème clair/sombre', 'Langue', 'Disposition du tableau de bord']
    }
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
          Paramètres
        </h1>
        <p className="text-gray-600 dark:text-gray-400">
          Configurez votre expérience PLV+
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {settingsCategories.map((category) => (
          <Card key={category.title} variant="elevated" className="hover:shadow-lg transition-shadow cursor-pointer">
            <CardHeader>
              <div className="flex items-center space-x-3">
                <div className="p-2 bg-primary-100 dark:bg-primary-900/20 rounded-lg">
                  <category.icon className="h-5 w-5 text-primary-600 dark:text-primary-400" />
                </div>
                <div>
                  <CardTitle className="text-lg">{category.title}</CardTitle>
                  <p className="text-sm text-gray-600 dark:text-gray-400">
                    {category.description}
                  </p>
                </div>
              </div>
            </CardHeader>
            <CardContent>
              <ul className="space-y-2">
                {category.items.map((item) => (
                  <li key={item} className="text-sm text-gray-700 dark:text-gray-300 hover:text-primary-600 dark:hover:text-primary-400 cursor-pointer">
                    • {item}
                  </li>
                ))}
              </ul>
            </CardContent>
          </Card>
        ))}
      </div>

      <Card variant="outlined">
        <CardContent className="p-8 text-center">
          <SettingsIcon className="h-12 w-12 text-gray-400 mx-auto mb-4" />
          <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
            Paramètres détaillés
          </h3>
          <p className="text-gray-600 dark:text-gray-400">
            Les paramètres détaillés seront disponibles dans une prochaine version.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};
